var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"nonzero","d":"M3.337 8.963H7.05V21H3.338V8.963zM5.138 3a2.25 2.25 0 0 1 2.25 2.138 2.329 2.329 0 0 1-2.25 2.25A2.25 2.25 0 0 1 3 5.138C3 3.957 3.957 3 5.138 3zm4.276 5.963h3.6v1.687A3.87 3.87 0 0 1 16.5 8.737c3.825 0 4.5 2.476 4.5 5.738V21h-3.713v-5.85c0-1.35 0-3.15-1.912-3.15s-2.25 1.575-2.25 3.037V21H9.413V8.963z"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
